import { createContext } from "react";

const LiveConnectionContext = createContext({
  ws: null,
});

export default LiveConnectionContext;
